import type { Tracker } from '@archipro-website/tracker';
import type { CreateEnquirySource } from '~/modules/enquiry';

export type EnquiryItemType =
    | 'professional'
    | 'product'
    | 'project'
    | 'article';

interface TrackProps {
    professionalName: string;
    itemID: number;
    itemType: EnquiryItemType;
    source: CreateEnquirySource;
    ctaLabel?: string;
    projectID?: number;
    professionalID: number;
}

/**
 * Track the `EnquiryReveal` event. Triggers when the enquiry form is revealed
 * to the user.
 * @see https://archipro.atlassian.net/browse/BA-1156
 */
export const trackEnquireReveal = (tracker: Tracker, props: TrackProps) => {
    tracker.log('EnquiryReveal', {
        url: new URL(window.location.href),
        label: props.professionalName,
        data: {
            Source: props.source,
            content_ids: [`${props.itemType}_${props.itemID}`],
            content_type: props.itemType,
            CTA_Label: `Message${props.ctaLabel}`,
            projectID: props.projectID || '',
            professionalID: props.professionalID,
        },
        targetTracker: ['archiproTracker', 'ga4Tracker'],
    });
};

/**
 * Track the `BookConsultationReveal` event. Triggers when the book consultation
 * form is revealed to the user.
 * @see https://archipro.atlassian.net/browse/PLAT-5939
 */
// TODO: add this back in when we implement the new way to track the book consultation form
// export const trackBookConsultationReveal = (
//     tracker: Tracker,
//     props: Omit<TrackProps, 'source' | 'ctaLabel'>
// ) => {
//     tracker.log('BookConsultationReveal', {
//         url: new URL(window.location.href),
//         label: props.professionalName,
//         data: {
//             ElementID: 'detail_header_bookConsultation',
//             Source: 'detail',
//             content_ids: [`${props.itemType}_${props.itemID}`],
//             content_type: props.itemType,
//         },
//     });
// };
